const getOrCreateLegendList = (chart) => {
  const legendContainer = chart.canvas.parentElement.parentElement;
  let listContainer = legendContainer.querySelector('ul');

  if (!listContainer) {
    listContainer = document.createElement('ul');
    listContainer.style.width = '100%';
    listContainer.style.display = 'flex';
    listContainer.style.justifyContent = 'center';
    listContainer.style.flexDirection = 'row';
    listContainer.style.paddingTop = '8px';
    listContainer.style.gap = '32px';

    legendContainer.appendChild(listContainer);
  }

  return listContainer;
};
export default {
  id: 'htmlLegend',
  afterUpdate(chart, args, options) {
    if (!options.display) return;

    const ul = getOrCreateLegendList(chart);

    // Remove old legend items
    while (ul.firstChild) {
      ul.firstChild.remove();
    }

    // Reuse the built-in legendItems generator
    const items = chart.options.plugins.legend.labels.generateLabels(chart);

    const { type } = chart.config;
    const isPieOrDoughnut = type === 'pie' || type === 'doughnut';

    items.forEach(item => {
      const checked = isPieOrDoughnut ? chart.getDataVisibility(item.index) : chart.isDatasetVisible(item.datasetIndex);

      const li = document.createElement('li');
      li.style.alignItems = 'center';
      li.style.cursor = 'pointer';
      li.style.display = 'flex';
      li.style.gap = '8px';
      li.style.flexDirection = 'row';

      li.onclick = (e) => {
        if (isPieOrDoughnut) {
          // Pie and doughnut charts only have a single dataset and visibility is per item
          chart.toggleDataVisibility(item.index);
        } else {
          chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
        }
        chart.update();
      };

      // Color box
      const boxSpan = document.createElement('input');
      boxSpan.name = `glib-chart-checkbox-${chart.id}`;
      boxSpan.type = 'checkbox';
      boxSpan.value = item.text;
      boxSpan.checked = checked;
      boxSpan.style.width = '15px';
      boxSpan.style.height = '15px';
      boxSpan.style.accentColor = item.fillStyle;

      // Text
      const textContainer = document.createElement('p');
      textContainer.style.fontSize = '14px';
      textContainer.style.fontWeight = '500';
      textContainer.style.lineHeight = '170%';
      textContainer.style.color = checked ? item.fillStyle : '';
      textContainer.style.margin = 0;
      textContainer.style.padding = 0;

      const text = document.createTextNode(item.text);
      textContainer.appendChild(text);

      li.appendChild(boxSpan);
      li.appendChild(textContainer);
      ul.appendChild(li);
    });
  }
};
